import cx from 'classnames';
import moment, { Moment } from 'moment';
// import PropTypes from 'prop-types';
import FullCalendar from '@tinper/rc-calendar/es/FullCalendar';
import events from 'dom-helpers/events';
import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { WebUI, delayEvent, detectZoom, fillSpace as fillSpaceFunc, timezoneAdaptor } from "../../wui-core/src/index";
// import { OrNull } from '../../wui-core/src/types/iCore';
import { getMomentConfig } from '../../wui-datepicker/src/_utils/lang';
import { getLangInfo } from '../../wui-locale/src/tool';
import { globalConfig } from '../../wui-provider/src';
import Select from '../../wui-select/src/index';
import CalendarFullBody from './CalendarFullBody';
import CalendarMutiRender from './CalendarMutiRender';
import generate from './Generate';
import i18n from './i18n/lang';
import type { CalendarProps, CalendarType } from './iCalendar';
import { getLunarContent, _disabledDate, getParentTitle, getMonthFormDates, setYear } from './util/utils';
const getWeekStartsOn = (weekStartsOn?: any) => weekStartsOn ?? globalConfig().getGlobalDataFormat()?.dayOfWeek
const { generateM } = generate;

const dateHeight = 81;
const defaultColomns = 54;
const defaultProps = {
    quickSelect: false,
    sidebar: true,
    locale: 'en-us',
    // weekStartsOn: 0,
    customInterval: 1,
    // showSingleMonth: false
    isShowWeek: true,
    // 时区相关默认值
    timezone: 'Asia/Shanghai',
    serverTimezone: 'Asia/Shanghai',
    enableTimezone: true
};

const appendMoreDom = (parentDom: any, htmlText: any, handleClick: any, top = '20px') => {
    let moreDom = document.createElement('div')
    moreDom.style.width = 'calc(100% + 1px)'
    moreDom.style.height = '20px'
    moreDom.style.background = '#3B82F6'
    moreDom.style.boxShadow = 'rgb(59, 130, 246) 0px 0px 1px inset'
    moreDom.style.position = 'absolute'
    moreDom.style.top = top;
    moreDom.innerHTML = htmlText;
    moreDom.setAttribute('moredom', 'is');
    moreDom.onclick = handleClick
    parentDom.appendChild(moreDom)
}
const Calendar: React.FC<CalendarProps<null>> = (props) => {
    const rootRef = useRef<any>(null);
    const scrollDiv = useRef<any>(null);
    // 屏幕缩放时 触发了滚动 事件
    const scalingRatioRef = useRef(1);
    // 切换年时 防止 切回的开关
    const inChangeYearDirRef = useRef(false);
    // eslint-disable-next-line no-undef
    const tomerRef = useRef<NodeJS.Timeout>();
    // fillSpace ：点击12月时自动滚动后 阻止 重复通过 自动计算 滚动高度 重设value
    const siderToScrollRef = useRef(false);
    const moveFlagRef = useRef<any>([]);
    const timerRef = useRef<any>(null);
    const timerMoveRef = useRef<any>(null);
    const timerChangeRef = useRef<any>(null);
    const startTitleValueRef = useRef<any>('');
    const endTitleValueRef = useRef<any>('');
    const dataFlagRef = useRef<any>('calendar' + new Date().getTime());
    const draggingRef = useRef<boolean>(false);
    // startY: any;
    const newHeightRef = useRef<any>(null);
    // const offsetTopRef = useRef<any>(0);
    // debouncedResize: any;
    // resizeObserver: any;
    const flagParentKeyRef = useRef<any>('');
    const dragStartTitleValueRef = useRef<any>([]);
    const editDomTopRef = useRef<any>(0);
    const flagDraggingRef = useRef<boolean>(false);
    const stableCallbacksRef = useRef<any>({});

    const { clsPrefix, value, defaultValue, mutiple, type: propsType, locale = 'en-us', scrollIntoValue, defaultScrollIntoValue, fillSpace, isDragEvent, isEditEvent, strideValue, fullscreen,
        cellAdaptHeight, markWeekend, weekStartsOn, quickSelect, disabledDate, dateCellRender, onYearChange, onCreateEvent, onMoreEvent, onCellClick, onSelect, renderDateHeaderCell, mode,
        defaultType, onPanelChange, onTypeChange, dateCellContentRender, dateFullCellRender, monthCellContentRender, monthFullCellRender, fieldid, getDateCellAttr, onTimeEventsClick, headerComponent,
        onQuickSelect, allowLunar, onChange, sidebar = true, customInterval = 1, isShowWeek = true,
        timezone: propsTimezone = 'Asia/Shanghai', serverTimezone = 'Asia/Shanghai', enableTimezone: propsEnableTimezone = true } = props;

    // 性能优化：同时区时自动禁用时区转换
    let enableTimezone = propsEnableTimezone;
    if (propsTimezone === 'Asia/Shanghai' && serverTimezone === 'Asia/Shanghai') {
        enableTimezone = false;
    }
    const timezone = propsTimezone;

    // ========== 时区转换工具函数 ==========

    // 显示用：任意类型 → timezone
    const initValue = useCallback((val?: Moment | string): Moment => {
        if (!val) {
            return generateM()();
        }

        if (typeof val === 'string') {
            // ✅ String类型：视为serverTimezone，转换为timezone显示
            const valueMoment = moment(val);
            if (enableTimezone) {
                const {diworkUTC, serverUTC} = timezoneAdaptor({
                    value: val,
                    format: 'YYYY-MM-DD HH:mm:ss',
                    timezone,
                    serverTimezone
                });
                return valueMoment.add(diworkUTC.secondDiff - serverUTC.secondDiff, 's');
            }
            return valueMoment;
        } else {
            // ✅ Moment类型：视为timezone，屏蔽deviceUTC
            if (enableTimezone) {
                const timeval = timezoneAdaptor({
                    value: val,
                    format: 'YYYY-MM-DD HH:mm:ss',
                    timezone,
                    serverTimezone,
                    isCbValue: false
                }).value;
                console.log('timeval', timeval);
                console.log('val', val);
                return timeval;
            }
            return val.clone();
        }
    }, [timezone, serverTimezone, enableTimezone]);

    // 回调用：timezone → serverTimezone
    const convertToServerTimezone = useCallback((val: Moment): Moment => {
        if (!enableTimezone) return val;

        const {serverUTC, deviceUTC} = timezoneAdaptor({
            value: val,
            format: 'YYYY-MM-DD HH:mm:ss',
            timezone,
            serverTimezone
        });
        return val.clone().add(serverUTC.secondDiff - deviceUTC.secondDiff, 's');
    }, [enableTimezone, timezone, serverTimezone]);

    // Initialize state with multiple useState hooks
    const [selectValuesMap, setSelectValuesMap] = useState<Map<string, boolean>>(() => {
        const map = new Map();
        if (mutiple) {
            let _value: (Moment | string)[] = (defaultValue || []) as (Moment | string)[];
            if ('value' in props) {
                _value = value as (Moment | string)[];
            }
            // ✅ P0: 时区转换 - 支持 String 和 Moment 两种类型
            _value?.forEach(v => {
                const convertedValue = initValue(v);
                map.set(convertedValue.format('YYYY-MM-DD'), true);
            });
        }
        return map;
    });

    // ✅ P0: 使用 initValue 转换初始值
    const [stateValue, setStateValue] = useState<Moment>(() =>
        initValue(scrollIntoValue || defaultScrollIntoValue)
    );

    const [fillSpaceStyle, setFillSpaceStyle] = useState<React.CSSProperties>({});
    const [hourFillSpaceStyle, setHourFillSpaceStyle] = useState<React.CSSProperties>({});
    const [highLightDate, setHighLightDate] = useState<string[]>([]);

    const [stateType, setStateType] = useState<string>(() => {
        if ('type' in props) {
            return propsType as string;
        }
        return mode || defaultType || "date";
    });

    const [current, setCurrent] = useState<Moment>(generateM()());
    const [focusedDay, setFocusedDay] = useState<string>('');
    const [isFlag, setIsFlag] = useState<boolean>(false);
    const [stateStrideValue, setStateStrideValue] = useState<any[]>(strideValue || []);
    const propsStrideValueRef = useRef<any[]>(strideValue);
    const [stateAllDataAdd, setStateAllDataAdd] = useState<any[]>([]);
    const [modalVisible, setModalVisible] = useState<boolean>(false);
    const deleteRef = useRef<boolean>(false);
    const [cellHeight, setCellHeight] = useState<number>(405);
    const [dataFlag, setDataFlag] = useState<string>('calendar' + new Date().getTime());

    const _locale = useMemo(() => getLangInfo(locale, i18n, 'calendar'), [locale])

    // Replace getDerivedStateFromProps with useEffect
    useEffect(() => {
        if (mutiple && scrollIntoValue) {
            // ✅ P0: 转换后再比较和设置
            const convertedValue = initValue(scrollIntoValue);
            if (convertedValue.format('YYYY-MM-DD') !== stateValue.format('YYYY-MM-DD')) {
                setStateValue(convertedValue);
            }
        }
    }, [scrollIntoValue, mutiple, initValue, stateValue]);

    // useEffect for stateValue changes with mutiple
    useEffect(() => {
        if (mutiple && (stateValue || fillSpace)) {
            setScroll();
        }
    }, [stateValue?.format('YYYY-MM-DD'), mutiple, fillSpaceStyle, hourFillSpaceStyle, fillSpace]);

    // useEffect for fillSpace changes
    // useEffect(() => {
    //     if (fillSpace && mutiple) {
    //         setScroll();
    //     }
    // }, [fillSpaceStyle, hourFillSpaceStyle, fillSpace, mutiple]);

    // useEffect for type prop changes
    useEffect(() => {
        if ('type' in props) {
            setStateType(propsType as string);
            // 从小时面板切换到日面板时，之前创建的事件都需要重新渲染
            if ((propsType === 'date' || propsType === 'month') && 'strideValue' in props && strideValue?.length > 0) {
                timerChangeRef.current = setTimeout(() => {
                    setCreatDom(strideValue)
                }, 500)
            }
            setCellHeightFunc(propsType);
        }
    }, [propsType]);

    // useEffect for strideValue and isEditEvent changes
    const prevStrideValueRef = useRef(strideValue);
    const prevIsEditEventRef = useRef(isEditEvent);
    useEffect(() => {
        if (('strideValue' in props && strideValue?.length != prevStrideValueRef.current?.length)
            || ('isEditEvent' in props && isEditEvent && isEditEvent !== prevIsEditEventRef.current && strideValue)) {
            propsStrideValueRef.current = strideValue;
            setStateStrideValue(strideValue);
            setCreatDom(strideValue);
        }
        prevStrideValueRef.current = strideValue;
        prevIsEditEventRef.current = isEditEvent;
    }, [strideValue, isEditEvent]);

    // useEffect for value prop changes with mutiple
    const prevValueRef = useRef(props.value);
    useEffect(() => {
        if ('value' in props && 'mutiple' in props && prevValueRef.current !== props.value) {
            const _value = props.value || defaultValue;
            const newSelectValuesMap = new Map();

            // ✅ P0: 时区转换后再存储
            (_value as (Moment | string)[])?.forEach((v: Moment | string) => {
                const convertedValue = initValue(v);
                newSelectValuesMap.set(convertedValue.format('YYYY-MM-DD'), true);
            });

            setSelectValuesMap(newSelectValuesMap);
        }
        prevValueRef.current = props.value;
    }, [props.value, mutiple, defaultValue, initValue]);

    // componentDidMount replacement
    useEffect(() => {
        scalingRatioRef.current = detectZoom();
        // 保证时间变化时，当前时间线实时更新
        timeFunc();
        if (fillSpace) {
            setFillSpaceFunc();
            events.on(window, 'resize', setFillSpaceFunc); // 浏览器窗口大小变化时重置
        } else {
            if (mutiple) {
                setScroll();
            }
        }
        creatSildeDom();
        setCreatDom(strideValue || []);
        setCellHeightFunc();

        // Cleanup function
        return () => {
            clearTimeout(tomerRef.current);
            clearTimeout(timerRef.current);
            clearTimeout(timerMoveRef.current);
            clearTimeout(timerChangeRef.current);
            events.off(window, 'resize', setFillSpaceFunc);
            rootRef.current?.removeEventListener('mousedown', handleMouseDown);
            rootRef.current?.removeEventListener('mouseup', handleMouseUp);
            rootRef.current?.removeEventListener('mousemove', handleMouseMove);
        };
    }, []); // Run only once on mount

    // 点击每条日程的事件
    const cellClick = useCallback((event: any) => {
        let dataFlag = event.target.getAttribute('data-add')
        let sameCellDom = null
        const tempStrideValue = propsStrideValueRef.current || stateStrideValue
        for (let i = 0; i < tempStrideValue?.length; i++) {
            if (dataFlag === tempStrideValue[i].dataFlag) {
                sameCellDom = tempStrideValue[i]
            }
        }
        let date = ''
        if (stateType == 'date') {
            date = event.target?.parentNode?.parentNode?.parentNode.getAttribute('datatitle')
        } else if (stateType == 'month') {
            date = event.target?.parentNode?.parentNode?.parentNode?.parentNode.getAttribute('datatitle')
        }
        onCellClick && onCellClick(event, sameCellDom, date)
    }, [stateType, onCellClick])

    const setFirstCellCotent = useCallback((obj: any) => {
        let startTime = new Date(obj.startTitleValue).getTime()
        let endTime = new Date(obj.titleValue).getTime()
        if (endTime <= startTime) {
            let targetDom: any = rootRef.current?.querySelector(`[datatitle="${obj.titleValue}"]`)?.querySelector(`[data-add="${obj.dataFlag}"]`)
            let endDom: any = rootRef.current?.querySelector(`[datatitle="${obj.startTitleValue}"]`)?.querySelector(`[data-add="${obj.dataFlag}"]`)
            let addDom: any = rootRef.current?.querySelectorAll(`[data-add="${obj.dataFlag}"]`)
            addDom.forEach((item: any, index: number) => {
                item.style.border = 'none'
                item.style.borderTop = '1px solid #fff'
                if (index !== 0 && index != addDom.length - 1) {
                    let oldFlagDom = item.querySelector(`[isFirst="is"]`)
                    item.style.width = 'calc(100%)'
                    oldFlagDom?.remove()
                    item.innerHTML = ''
                }
            })
            if (endDom) {
                endDom.style.width = 'calc(100% - 4px)'
                // endDom = endDom
                targetDom.innerHTML = ''
                targetDom.style.borderLeft = '3px solid #3b82f6'
                targetDom.style.borderTopLeftRadius = '3px'
                targetDom.style.borderBottomLeftRadius = '3px'
                if (isEditEvent) {
                    let flagDom = document.createElement('div')
                    flagDom.style.left = '0'
                    flagDom.setAttribute('isFirst', 'is')
                    flagDom.classList.add(`${clsPrefix}-drag-flag-online`)
                    flagDom.onmousedown = itemDown
                    targetDom.appendChild(flagDom)
                    // 最后一个元素内的拖拽元素定位到元素后面
                    let lastDragDom = endDom.querySelector(`[isFirst="is"]`)
                    if (lastDragDom) {
                        lastDragDom.style.left = 'calc(100% - 7px)'
                    }
                }
                let textDom = document.createElement('span')
                textDom.innerHTML = obj.tex
                targetDom.appendChild(textDom)
                // targetDom.innerHTML = obj.tex
                targetDom.setAttribute('title', obj.tex)
            }
        } else if (endTime >= startTime) {
            let targetDom: any = rootRef.current?.querySelector(`[datatitle="${obj.startTitleValue}"]`)?.querySelector(`[data-add="${obj.dataFlag}"]`)
            let endDom: any = rootRef.current?.querySelector(`[datatitle="${obj.titleValue}"]`)?.querySelector(`[data-add="${obj.dataFlag}"]`)
            let addDom: any = rootRef.current?.querySelectorAll(`[data-add="${obj.dataFlag}"]`)
            addDom?.forEach((item: any, index: number) => {
                item.style.border = 'none'
                item.style.borderTop = '1px solid #fff'
                if (index !== 0 && index != addDom.length - 1) {
                    let oldFlagDom = item.querySelector(`[isFirst="is"]`)
                    item.style.width = 'calc(100%)'
                    oldFlagDom?.remove()
                    item.innerHTML = ''
                }
            })
            if (endDom && targetDom) {
                endDom.style.width = 'calc(100% - 4px)'
                targetDom.innerHTML = ''
                targetDom.style.borderLeft = '3px solid #3b82f6'
                targetDom.style.borderTopLeftRadius = '3px'
                targetDom.style.borderBottomLeftRadius = '3px'
                if (isEditEvent) {
                    let flagDom = document.createElement('div')
                    flagDom.style.left = '0'
                    flagDom.setAttribute('isFirst', 'is')
                    flagDom.classList.add(`${clsPrefix}-drag-flag-online`)
                    flagDom.onmousedown = itemDown
                    targetDom.appendChild(flagDom)
                    // 最后一个元素内的拖拽元素定位到元素后面
                    let lastDragDom = endDom.querySelector(`[isFirst="is"]`)
                    if (lastDragDom) {
                        lastDragDom.style.left = 'calc(100% - 7px)'
                    }
                }
                let textDom = document.createElement('span')
                textDom.innerHTML = obj.tex
                targetDom.appendChild(textDom)
                // targetDom.innerHTML = obj.tex
                targetDom.setAttribute('title', obj.tex)
            }
        }
    }, [isEditEvent])

    const setOtherDomPosition = useCallback((bodyDom: any, dataFlag: string) => {
        let allDataAddDom = bodyDom.querySelectorAll(`[data-add]`)
        const gapNum = 0
        allDataAddDom.forEach((item: any, index: number) => {
            let itemDataAdd = item?.getAttribute('data-add')
            if (itemDataAdd != dataFlag) {
                let addSameDataAddDom = rootRef.current?.querySelectorAll(`[data-add="${itemDataAdd}"]`)
                addSameDataAddDom?.forEach((val: any) => {
                    if (index == 1) {
                        // let styleAll = window.getComputedStyle(item)
                        if (parseInt(item.style?.top) > 20 + gapNum) {
                            // console.log('进入111111111')
                        } else {
                            val.style.position = 'absolute'
                            val.style.top = index * 20 + gapNum + 'px'
                        }
                    } else {
                        let styleAll = window.getComputedStyle(val)
                        if (parseInt(styleAll?.top) > index * (20 + gapNum)) {
                            val.style.top = parseInt(styleAll?.top) + 'px'
                        } else {
                            val.style.top = index * (20 + gapNum) + 'px'
                        }
                        val.style.position = 'absolute'
                        // val.style.top = index * 20 + 'px'
                        // let childrenDom = bodyDom.querySelectorAll(`[data-add]`)
                        // 每一项的父元素
                        let parentDom = val.parentNode
                        // let newcDom = parentDom.querySelector(`[moredom="is"]`)
                        let allchildDom = parentDom?.querySelectorAll(`[data-add]`)
                        allchildDom?.forEach((domItem: any, ind: number) => {
                            let parentDom1 = domItem.parentNode
                            let newcDom = parentDom1.querySelector(`[moredom="is"]`)
                            if (newcDom) {
                                newcDom.innerText = `${_locale.langMap.more}`
                                return;
                            }
                            if (cellAdaptHeight) {
                                let diffNum = Math.floor((cellHeight - 30) / 20)
                                if (ind <= diffNum - 1 && parseInt(domItem.style.top) > (diffNum - 1) * 20) {
                                    appendMoreDom(parentDom1, `${_locale.langMap.more}`, moreDomHandle, `${(diffNum - 1) * 20}px`)
                                } else if (ind == allchildDom?.length - 1 && parseInt(domItem.style.top) > (diffNum - 1) * 20) {
                                    appendMoreDom(parentDom1, `${_locale.langMap.more}`, moreDomHandle, `${(diffNum - 1) * 20}px`)
                                } else if (ind > diffNum - 1) {
                                    appendMoreDom(parentDom1, `${_locale.langMap.more}`, moreDomHandle, `${(diffNum - 1) * 20}px`)
                                }
                            } else {
                                if (ind == 0 && domItem.style.top != '0px' || ind == 0 && domItem.style.top != '20px') {
                                    appendMoreDom(parentDom1, `${_locale.langMap.more}`, moreDomHandle)
                                } else if (ind == 1 && domItem.style.top != '20px') {
                                    appendMoreDom(parentDom1, `${_locale.langMap.more}`, moreDomHandle)
                                } else {
                                    appendMoreDom(parentDom1, `${_locale.langMap.more}`, moreDomHandle)
                                }
                            }
                        })
                    }
                })
            }
        })
    }, [_locale, cellAdaptHeight])

    // 删除之后下方事件上移
    const moveUpDom = useCallback((_en: Element) => {
        let parentNode = _en.parentNode
        let allChildNode = parentNode?.querySelectorAll(`[data-add]`)
        let allDataAdd: string[] = []
        allChildNode?.forEach((item: any) => {
            let titleFlag = item.getAttribute('data-add')
            allDataAdd.push(titleFlag)
        })
        let oldDataAdd = [...stateAllDataAdd]
        moveFlagRef.current = [...moveFlagRef.current, ...allDataAdd]
        setStateAllDataAdd([...oldDataAdd, ...allDataAdd])
        clearTimeout(timerMoveRef.current) // 删除之后，下方dom上移，确保每次删除dom，下方dom上移只执行一次
        timerMoveRef.current = setTimeout(() => {
            let moveDomArr = Array.from(new Set([...moveFlagRef.current]))
            moveDomArr.forEach(list => {
                let sameFlagDom: any = rootRef.current?.querySelectorAll(`[data-add="${list}"]`)
                // let isMove = true
                // sameFlagDom.forEach((val: any) => {
                //     // 这里 那获取每个元素的父元素下的第一个子元素是否top值为0，如果为0，则不上移
                //     let parentElement = val.parentNode.querySelectorAll(`[data-add]`)
                //     let firstChildDomStyle = window.getComputedStyle(parentElement[0])
                //     if (parseInt(firstChildDomStyle?.top) === 0) {
                //         isMove = false
                //     }
                // })
                // 删除dom之后，下方dom上移逻辑
                sameFlagDom.forEach((li: any) => {
                    let itemStyle = window.getComputedStyle(li)
                    if (parseInt(itemStyle?.top) > 0) {
                        li.style.top = (parseInt(itemStyle?.top) - 20) + 'px'
                    } else {
                        // return
                    }
                    // 删除后隐藏日程数量更新
                    let moveParentDom = li.parentNode
                    let moveChildDom = moveParentDom?.querySelectorAll(`[data-add]`)
                    if (moveChildDom?.length == 1) {
                        let moveDomStyle = window.getComputedStyle(moveChildDom[0])
                        if (parseInt(moveDomStyle?.top) == 20) {
                            let moreDom = moveParentDom.querySelector(`[moredom="is"]`)
                            if (moreDom) {
                                moreDom.remove()
                            }
                        }
                    } else if (moveChildDom?.length == 2) {
                        let topArr: any = []
                        moveChildDom.forEach((item: any) => {
                            let moveDomStyle = window.getComputedStyle(item)
                            topArr.push(parseInt(moveDomStyle?.top))
                        })
                        topArr.sort((a: any, b: any) => a - b)
                        if (topArr[0] == 0 && topArr[1] == 20) {
                            let moreDom = moveParentDom.querySelector(`[moredom="is"]`)
                            if (moreDom) {
                                moreDom.remove()
                            }
                        } else if (topArr[0] >= 20) {
                            let moreDom = moveParentDom.querySelector(`[moredom="is"]`)
                            if (moreDom) {
                                // moreDom.innerText = `${_locale.langMap.moreBefore} ${2} ${_locale.langMap.moreAfter}`
                                moreDom.innerText = `${_locale.langMap.more}`
                            }
                        }
                    } else if (moveChildDom?.length > 2) {
                        let topArr: any = []
                        moveChildDom.forEach((item: any) => {
                            let moveDomStyle = window.getComputedStyle(item)
                            topArr.push(parseInt(moveDomStyle?.top))
                        })
                        topArr.sort((a: any, b: any) => a - b)
                        if (topArr[0] == 0) {
                            let moreDom = moveParentDom.querySelector(`[moredom="is"]`)
                            if (moreDom) {
                                // moreDom.innerText = `${_locale.langMap.moreBefore} ${moveChildDom?.length - 1} ${_locale.langMap.moreAfter}`
                                moreDom.innerText = `${_locale.langMap.more}`
                            }
                        } else if (topArr[0] > 0) {
                            let moreDom = moveParentDom.querySelector(`[moredom="is"]`)
                            if (moreDom) {
                                // moreDom.innerText = `${_locale.langMap.moreBefore} ${moveChildDom?.length} ${_locale.langMap.moreAfter}`
                                moreDom.innerText = `${_locale.langMap.more}`
                            }
                        }
                    }
                })
            })
        }, 0)
    }, [_locale, stateAllDataAdd])

    const itemMove = (e: any) => {
        // console.log('鼠标移动', e)
        if (!flagDraggingRef.current) return
        let allKeyDom = rootRef.current?.querySelectorAll(`[data-add="${flagParentKeyRef.current}"]`)
        let keyTimeArr = []
        allKeyDom?.forEach((item: any) => {
            let itemTime = getParentTitle(item)
            keyTimeArr.push(itemTime)
        })
        let endTime = getParentTitle(e.target)
        let startTitleValue = dragStartTitleValueRef.current[0]
        if (new Date(endTime).getTime() < new Date(dragStartTitleValueRef.current[0]).getTime()) {
            startTitleValue = dragStartTitleValueRef.current[dragStartTitleValueRef.current?.length - 1]
        }
        let obj = { startTitleValue: startTitleValue, titleValue: endTime, dataFlag: flagParentKeyRef.current }
        setCreatDom([obj], 'flagMouseMove')
    }
    stableCallbacksRef.current.itemMove = itemMove

    const itemUp = useCallback((e: any) => {
        if (flagDraggingRef.current) {
            let allKeyDom = rootRef.current?.querySelectorAll(`[data-add="${flagParentKeyRef.current}"]`)
            let keyTimeArr = []
            allKeyDom?.forEach((item: any) => {
                let itemTime = getParentTitle(item)
                keyTimeArr.push(itemTime)
            })
            // console.log('所有的时间-------------', keyTimeArr)
            let endTime = getParentTitle(e.target)
            let startTitleValue = dragStartTitleValueRef.current[0]
            if (new Date(endTime).getTime() < new Date(dragStartTitleValueRef.current[0]).getTime()) {
                startTitleValue = dragStartTitleValueRef.current[dragStartTitleValueRef.current?.length - 1]
            }
            onCreateEvent && onCreateEvent({ start: startTitleValue, end: endTime, dataFlag: flagParentKeyRef.current })
            let lastValue = strideValue && strideValue?.length > 0 ? strideValue[strideValue?.length - 1] : []
            setFirstCellCotent(lastValue)
            setModalVisible(true);
            setDataFlag(flagParentKeyRef.current);
            // 拖拽完成之后创建元素
            let allKeyDomCopy = rootRef.current?.querySelectorAll(`[data-add="${flagParentKeyRef.current}"]`)
            allKeyDomCopy?.forEach((item: any, index: Number) => {
                if (index === allKeyDomCopy!?.length - 1) {
                    let flagDom = document.createElement('div')
                    // flagDom.style.width = '7px'
                    // flagDom.style.height = '20px'
                    // flagDom.style.background = '#999'
                    // flagDom.style.position = 'absolute'
                    flagDom.style.right = '0'
                    flagDom.setAttribute('isFirst', 'is')
                    flagDom.classList.add(`${clsPrefix}-drag-flag-online`)
                    flagDom.onmousedown = itemDown
                    item.appendChild(flagDom)
                }
            })
        }
        document.removeEventListener('mousemove', stableCallbacksRef.current.itemMove)
        flagDraggingRef.current = false
    }, [onCreateEvent, strideValue])

    const itemDown = useCallback((e: any) => {
        e.preventDefault()
        e.stopPropagation()
        let flagParent = e.target.parentNode
        flagParentKeyRef.current = flagParent.getAttribute('data-add')
        let allKeyDom = rootRef.current?.querySelectorAll(`[data-add="${flagParentKeyRef.current}"]`)
        let keyTimeArr: any = []
        allKeyDom?.forEach((item: any) => {
            let itemTime = getParentTitle(item)
            keyTimeArr.push(itemTime)
        })
        dragStartTitleValueRef.current = keyTimeArr
        editDomTopRef.current = window.getComputedStyle(flagParent)?.top
        flagDraggingRef.current = false
        setTimeout(() => {
            flagDraggingRef.current = true
        }, 50)
        document.addEventListener('mousemove', stableCallbacksRef.current.itemMove)
        document.addEventListener('mouseup', itemUp)
    }, [itemUp])

    const setCreatDom = useCallback((arr: any, _mouseOver?: any) => {
        if (dateCellRender) return
        let addDataDom = rootRef.current?.querySelectorAll('[data-add]')
        let allDataAdd: any = []
        let lastDataAdd: any = []
        addDataDom?.forEach((item: any) => {
            let domGetAttr = item.getAttribute('data-add')
            allDataAdd.push(domGetAttr)
        })
        let newDataArr = Array.from(new Set(allDataAdd))
        arr.forEach(({ startTitleValue, titleValue, dataFlag, tex }: any) => {
            let startTime = new Date(startTitleValue)
            let endTime = new Date(titleValue)
            if (startTime.getTime() >= endTime.getTime()) {
                // 鼠标按下时间大于结束时间
                // 计算时间段内的所有dom
                let sectionDom: any = []
                let allDom: any = rootRef.current?.querySelectorAll('[datatitle]')
                allDom.forEach((item: any) => {
                    let itemTitle = item?.getAttribute('datatitle')
                    let currentTime = new Date(itemTitle).getTime()
                    if (titleValue && endTime.getTime() <= currentTime && currentTime <= startTime.getTime()) {
                        sectionDom.push(item)
                    } else {
                        let otherDom = item.querySelector(`[data-add="${dataFlag}"]`)
                        if (otherDom) {
                            otherDom.remove()
                        }
                    }
                })
                sectionDom.forEach((item: any, index: number) => {
                    // let itemValue = item?.getAttribute('datatitle')
                    // if (endTime.getTime() < new Date(itemValue).getTime() && new Date(itemValue).getTime() < startTime.getTime()) {
                    let bodyDom = item.querySelector('.wui-calendar-cell-body')
                    let newDom = document.createElement('div')
                    newDom.style.width = 'calc(100% + 1px)'
                    newDom.style.height = '20px'
                    newDom.style.background = '#EFF6FF'
                    // newDom.style.borderTop = '1px solid #ffa600'
                    // newDom.style.borderBottom = '1px solid #ffa600'
                    // newDom.style.boxShadow = 'rgb(59, 130, 246) 0px 0px 1px inset'
                    newDom.style.border = '1px solid #3b82f6'
                    if (index != 0) {
                        newDom.style.borderLeft = 'none'
                    }
                    // newDom.style.borderLeft = 'none'
                    newDom.style.position = 'absolute'
                    if (_mouseOver == 'flagMouseMove') {
                        newDom.style.top = editDomTopRef.current
                    } else {
                        newDom.style.top = '0'
                    }
                    // newDom.onclick = cellClick(sectionDom, dataFlag)
                    // newDom.cdom = 'tt'
                    newDom.setAttribute('data-add', dataFlag)
                    newDom.onclick = cellClick
                    let newcDom = bodyDom.querySelector(`[data-add="${dataFlag}"]`)
                    if (deleteRef.current) {
                        newcDom.remove()
                        if (bodyDom.firstChild) {
                            bodyDom.insertBefore(newDom, bodyDom.firstChild)
                        } else {
                            bodyDom.appendChild(newDom)
                        }
                        bodyDom.style.position = 'relative'
                        setOtherDomPosition(bodyDom, dataFlag)
                    } else {
                        if (!newcDom) {
                            if (bodyDom.firstChild) {
                                bodyDom.insertBefore(newDom, bodyDom.firstChild)
                            } else {
                                bodyDom.appendChild(newDom)
                            }
                            bodyDom.style.position = 'relative'
                            setOtherDomPosition(bodyDom, dataFlag)
                        }
                    }
                    // if (!newcDom) {
                    //     if (bodyDom.firstChild) {
                    //         bodyDom.insertBefore(newDom, bodyDom.firstChild)
                    //     } else {
                    //         bodyDom.appendChild(newDom)
                    //     }
                    //     bodyDom.style.position = 'relative'
                    //     setOtherDomPosition(bodyDom, dataFlag)
                    // }
                })
            } else if (startTime.getTime() < endTime.getTime()) {
                // 鼠标按下事件小于结束时间
                // 计算时间段内的所有dom
                let sectionDom: any = []
                let allDom: any = rootRef.current?.querySelectorAll('[datatitle]')
                allDom?.forEach((item: any) => {
                    let itemTitle = item?.getAttribute('datatitle')
                    let currentTime = new Date(itemTitle).getTime()
                    if (titleValue && endTime.getTime() >= currentTime && currentTime >= startTime.getTime()) {
                        sectionDom.push(item)
                    } else {
                        let otherDom = item.querySelector(`[data-add="${dataFlag}"]`)
                        if (otherDom) {
                            otherDom.remove()
                        }
                    }
                })
                sectionDom.forEach((item: any, index: number) => {
                    // let itemValue = item?.getAttribute('datatitle')
                    // if (endTime.getTime() < new Date(itemValue).getTime() && new Date(itemValue).getTime() < startTime.getTime()) {
                    let bodyDom = item.querySelector('.wui-calendar-cell-body')
                    // let bodyDom = type === 'date' ? item.querySelector('.wui-calendar-cell-body') : item.querySelector('.wui-calendar-month-panel-month')
                    let newDom = document.createElement('div')
                    newDom.style.width = 'calc(100% + 1px)'
                    newDom.style.height = '20px'
                    newDom.style.background = '#EFF6FF'
                    // newDom.style.borderTop = '1px solid #ffa600'
                    // newDom.style.borderBottom = '1px solid #ffa600'
                    // newDom.style.boxShadow = 'rgb(59, 130, 246) 0px 0px 1px inset'
                    newDom.style.border = '1px solid #3b82f6'
                    // newDom.style.borderLeft = 'none'
                    if (index != 0) {
                        newDom.style.borderLeft = 'none'
                    }
                    newDom.style.position = 'absolute'
                    if (_mouseOver == 'flagMouseMove') {
                        newDom.style.top = editDomTopRef.current
                    } else {
                        newDom.style.top = '0'
                    }
                    // newDom.style.top = '0'
                    // newDom.onclick = cellClick(sectionDom, dataFlag)
                    newDom.setAttribute('data-add', dataFlag)
                    newDom.onclick = cellClick
                    // console.log('每个单元格-----------540', newDom, sectionDom)
                    if ((index == sectionDom.length - 1) && _mouseOver !== 'mouseMove' && _mouseOver !== 'flagMouseMove') {
                        let flagDom = document.createElement('div')
                        // flagDom.style.width = '7px'
                        // flagDom.style.height = '20px'
                        // flagDom.style.background = '#999'
                        // flagDom.style.position = 'absolute'
                        flagDom.style.right = '0'
                        flagDom.setAttribute('isFirst', 'is')
                        flagDom.classList.add(`${clsPrefix}-drag-flag-online`)
                        flagDom.onmousedown = itemDown
                        newDom.appendChild(flagDom)
                    }
                    let newcDom = bodyDom.querySelector(`[data-add="${dataFlag}"]`)
                    if (deleteRef.current) {
                        newcDom?.remove()
                        if (bodyDom.firstChild) {
                            bodyDom.insertBefore(newDom, bodyDom.firstChild)
                        } else {
                            bodyDom.appendChild(newDom)
                        }
                        bodyDom.style.position = 'relative'
                        setOtherDomPosition(bodyDom, dataFlag)
                    } else {
                        if (!newcDom) {
                            // newcDom.remove()
                            if (bodyDom.firstChild) {
                                bodyDom.insertBefore(newDom, bodyDom.firstChild)
                            } else {
                                bodyDom.appendChild(newDom)
                            }
                            bodyDom.style.position = 'relative'
                            setOtherDomPosition(bodyDom, dataFlag)
                        }
                    }
                })
            }
            lastDataAdd.push(dataFlag)
            if (!['mouseMove', 'flagMouseMove'].includes(_mouseOver)) {
                setFirstCellCotent({ startTitleValue, titleValue, dataFlag, tex })
            }
        })
        let initProps = strideValue || []
        let strideValueArr = [...initProps, ...arr]
        strideValueArr.forEach(item => {
            lastDataAdd.push(item.dataFlag)
        })
        let createDeleteArr = Array.from(new Set(lastDataAdd))
        let differArr = newDataArr.filter(item => !createDeleteArr.includes(item))
        let domPath = null
        differArr.forEach(item => {
            domPath = rootRef.current?.querySelectorAll(`[data-add="${item}"]`)
            domPath?.forEach((_en: any) => {
                moveUpDom(_en)
                _en.remove()
            })
        })
    }, [strideValue, dateCellRender, setOtherDomPosition, setFirstCellCotent, cellClick, itemDown, moveUpDom])

    // 鼠标移动事件
    const handleMouseMove = useCallback((event: any) => {
        if (!isDragEvent) return
        if (!(fullscreen && mutiple && (propsType === 'date' || propsType === 'month'))) return
        if (!draggingRef.current) return
        moveFlagRef.current = []
        // let mouseMoveEvent = event || window.event;
        let parentElement = event.target.parentNode
        let titleValue = getParentTitle(parentElement) // 不能只取一层父级元素，内部添加元素 这个逻辑有问题
        // let bodyDom = event.target.querySelector('.wui-calendar-cell-body')
        setCreatDom([{ startTitleValue: startTitleValueRef.current, titleValue, dataFlag: dataFlagRef.current }], 'mouseMove')
        newHeightRef.current = 0
    }, [isDragEvent, fullscreen, mutiple, propsType, setCreatDom])

    // 鼠标按下事件
    const handleMouseDown = useCallback((event: any) => {
        let isTableHead = event.target.classList
        if (!isDragEvent || isTableHead.contains(`${clsPrefix}-column-header-inner`) || isTableHead.contains(`${clsPrefix}-column-header`) || isTableHead.contains(`${clsPrefix}-full-header`) || isTableHead.contains(`${clsPrefix}-more-event`)) return
        event.preventDefault(); // 阻止默认行为（如选中文本）
        if (!(fullscreen && mutiple && (stateType === 'date' || stateType === 'month'))) return
        draggingRef.current = false
        timerRef.current = setTimeout(() => {
            draggingRef.current = true
        }, 50)
        startTitleValueRef.current = '' // 鼠标按下时的位置
        endTitleValueRef.current = ''
        // let mouseDownEvent = event || window.event;
        // startY = null; // 计算相对于DIV上边界的距离
        newHeightRef.current = null
        let parentElement = event.target.parentNode
        startTitleValueRef.current = getParentTitle(parentElement)
        dataFlagRef.current = 'calendar' + new Date().getTime()
        setDataFlag(dataFlagRef.current);
        deleteRef.current = false;
        rootRef.current?.addEventListener('mousemove', handleMouseMove);
    }, [isDragEvent, clsPrefix, stateType, fullscreen, mutiple])

    // 鼠标松开事件
    const handleMouseUp = useCallback((event: any) => {
        if (!isDragEvent) return
        if (!(fullscreen && mutiple && (stateType === 'date' || stateType === 'month'))) return
        clearTimeout(timerRef.current)
        if (!draggingRef.current) {
            // console.log('执行了点击吗', event)
        } else {
            // console.log('执行了移动吗', event)
            if (newHeightRef.current !== undefined && newHeightRef.current !== null && !isNaN(newHeightRef.current)) {
                let parentElement = event.target.parentNode
                endTitleValueRef.current = getParentTitle(parentElement)
                // onMouseHandle && onMouseHandle({startTitleValue, titleValue: endTitleValue, dataFlag}, setFirstCellCotent)
                // onMouseHandle && onMouseHandle({startTitleValue: startTitleValueRef.current, titleValue: endTitleValueRef.current, dataFlag: dataFlagRef.current})
                onCreateEvent && onCreateEvent({ start: startTitleValueRef.current, end: endTitleValueRef.current, dataFlag: dataFlagRef.current })
                let lastValue = strideValue && strideValue?.length > 0 ? strideValue[strideValue?.length - 1] : []
                setFirstCellCotent(lastValue)
                setModalVisible(true);
                setDataFlag(dataFlagRef.current);
                // 拖拽完成之后创建元素
                if (isEditEvent) {
                    let allKeyDom = rootRef.current?.querySelectorAll(`[data-add="${dataFlagRef.current}"]`)
                    allKeyDom?.forEach((item: any, index: Number) => {
                        if (index === allKeyDom!?.length - 1) {
                            let flagDom = document.createElement('div')
                            flagDom.style.right = '0'
                            flagDom.setAttribute('isFirst', 'is')
                            flagDom.classList.add(`${clsPrefix}-drag-flag-online`)
                            flagDom.onmousedown = itemDown
                            item.appendChild(flagDom)
                        }
                    })
                }
            }
            // startY = null; // 重置变量
            newHeightRef.current = null;
            // contentText = ''
        }
        rootRef.current?.removeEventListener('mousemove', handleMouseMove)
    }, [isDragEvent, fullscreen, mutiple, stateType, strideValue, isEditEvent, onCreateEvent, handleMouseMove])

    // 滑动鼠标添加滑过区域
    const creatSildeDom = useCallback(() => {
        if (!isDragEvent) return
        rootRef.current?.addEventListener('mousedown', handleMouseDown)
        rootRef.current?.addEventListener('mouseup', handleMouseUp)
    }, [isDragEvent, handleMouseDown, handleMouseUp])

    // 点击更多的收起项
    const moreDomHandle = useCallback((e: any) => {
        e.preventDefault()
        e.stopPropagation()
        let parentNode = e.target.parentNode
        let allDataAdd = parentNode.querySelectorAll(`[data-add]`)
        let sameCellDom: any = []
        // console.log('allDataAdd', allDataAdd)
        allDataAdd.forEach((item: any) => {
            let dataFlag = item.getAttribute('data-add')
            // console.log('dataFlag', dataFlag)
            // console.log('stateStrideValue', stateStrideValue)
            const tempStrideValue = propsStrideValueRef.current || stateStrideValue
            for (let i = 0; i < tempStrideValue?.length; i++) {
                if (dataFlag === tempStrideValue[i].dataFlag) {
                    sameCellDom.push(tempStrideValue[i])
                }
            }
        })
        let date = ''
        if (propsType == 'date') {
            date = parentNode?.parentNode?.parentNode.getAttribute('datatitle')
        } else if (propsType == 'month') {
            date = parentNode?.parentNode?.parentNode?.parentNode.getAttribute('datatitle')
        }
        onMoreEvent && onMoreEvent(e, sameCellDom, date)
    }, [propsType, onMoreEvent])

    // modal点击确认回调
    const onOk = () => {
        let { onModalOk } = props
        setModalVisible(false);
        onModalOk && onModalOk(onCloseModal)
    }

    // 取消创建事件
    const onCloseSlide = () => {
        let dataFlagLocal = dataFlag
        setModalVisible(false);
        let domPath = rootRef.current?.querySelectorAll(`[data-add="${dataFlagLocal}"]`)
        domPath?.forEach((_en: any) => {
            _en.remove()
        })
        deleteEvent()
    }

    // 创建成功之后关闭弹窗
    const onCloseModal = () => {
        setModalVisible(false);
    }

    // 内部删除逻辑
    const deleteEvent = () => {
        // let {dataFlag} = state
        let newStrideValue = [...strideValue]
        let newArr: any = []
        newStrideValue.forEach(item => {
            if (item.dataFlag != dataFlag) {
                newArr.push(item)
            }
        })
        setStateStrideValue(newArr);
        propsStrideValueRef.current = newArr;
        deleteRef.current = true;
        // Use setTimeout to trigger setCreatDom after state update
        setCreatDom(newArr)
    }

    const setFillSpaceFunc = () => {
        // fillSpace already destructured from props at the beginning
        if (!fillSpace) return;
        fillSpaceFunc(rootRef.current!, undefined, (_element, _parent, _noPaddingMaxW, noPaddingMaxH) => {
            if (mutiple) {
                // 暂时固定 处理 下版本完整处理
                if (stateType === 'hour') {
                    const height = noPaddingMaxH - rootRef.current!.getElementsByClassName('wui-calendar-full-header')[0].clientHeight - rootRef.current!.getElementsByClassName('wui-calendar-allDay-container')[0].clientHeight
                    setHourFillSpaceStyle({
                        height: height + 'px'
                    })
                } else {
                    const height = noPaddingMaxH - rootRef.current!.getElementsByTagName('thead')[0]?.clientHeight - rootRef.current!.getElementsByClassName('wui-calendar-full-header')[0].clientHeight;
                    setFillSpaceStyle({
                        // width: noPaddingMaxW + 'px',
                        height: (height) + 'px'
                    });
                    // hourFillSpaceStyle: {} // 是否加上清空，不加可缓存下高度切换时不会有闪烁情况
                    setScroll();
                }
            } else {
                setFillSpaceStyle({
                    // width: noPaddingMaxW + 'px',
                    height: (noPaddingMaxH || 450) + 'px'
                });
                setHourFillSpaceStyle({});
            }
        })
    }
    // 保证时间变化时，当前时间线实时更新
    const timeFunc = () => {
        // temp后更新一次
        let temp = (60 - Number(generateM()().format('ss'))) * 1000;
        tomerRef.current = setTimeout(() => {
            setCurrent(generateM()())
            clearTimeout(tomerRef.current)
            timeFunc();
        }, (temp))
    }
    // componentWillUnmount is handled in useEffect cleanup
    const setScroll = useCallback((v?: Moment) => {
        const scalingRatio = detectZoom();
        let value1 = (v?.clone?.() || stateValue!.clone());
        value1 = value1.date(1);
        const year = value1.year();
        const firstDays = generateM()(`${year}-01-01`).day();
        const scrollDates = value1.dayOfYear() + firstDays - 1;
        const scrollRows = parseInt(scrollDates / 7 + "");
        if (scrollDiv.current) {
            const tbody = scrollDiv.current.getElementsByClassName(`${clsPrefix}-tbody`)[0];
            let scrollTop = scrollRows * dateHeight + Math.floor(10 * scalingRatio);
            if (cellAdaptHeight) {
                scrollTop = scrollRows * cellHeight + Math.floor(10 * scalingRatio);
            }
            // 显示区域大于整月时 fillSpace 特殊计算
            if (tbody?.scrollHeight && tbody.clientHeight && scrollTop > tbody.scrollHeight - tbody.clientHeight - Math.floor(10 * scalingRatio)) {
                scrollTop = tbody.scrollHeight - tbody.clientHeight - Math.floor(10 * scalingRatio);
                siderToScrollRef.current = true;
            }
            if (tbody) tbody.scrollTop = scrollTop;
        }
    }, [stateValue])
    const onFCChange = (mVal: Moment) => {
        mVal = generateM()(mVal.format());

        setStateValue(mVal);
        const callbackValue = convertToServerTimezone(mVal);
        // fixbug QDJCJS-33323 选中日期时，滚动到指定日期 并触发选中
        if (stateType === 'date' && mutiple) {
            setScroll(mVal);
            onSelect && onSelect(callbackValue);
        }
        if (!mutiple) {
            onChange && onChange(callbackValue);
        }
    }

    // 兼容rc-calendar的onSelect回调
    const onFCSelect = (mVal: Moment) => {
        mVal = generateM()(mVal.format());

        // ✅ P0: 回调前转换为 serverTimezone
        if (onSelect) {
            const callbackValue = convertToServerTimezone(mVal);
            onSelect(callbackValue);
        }
    }

    const typeChange = (valType: CalendarType) => {
        if (valType === 'date' && mutiple) {
            setTimeout(() => {
                setScroll(stateValue);
            }, 200)
        }
        setTimeout(() => { // 切换面板之后等加载完在计算高度
            setFillSpaceFunc()
        }, 200)
        setStateType(valType);
        (onTypeChange && onTypeChange(valType)) || (onPanelChange && onPanelChange(valType))
    }

    const getScrollRows = useCallback(() => {
        const { scrollTop } = scrollDiv.current!.getElementsByClassName(`${clsPrefix}-tbody`)[0];
        return scrollTop % dateHeight ? parseInt(scrollTop / dateHeight + 1 + "") : scrollTop / dateHeight;
    }, [clsPrefix])

    const getScrollDates = useCallback(() => {
        const value = stateValue;
        const year = value.year();
        const firstDateOfYear = generateM()(`${year}-01-01`).locale('en-us')
        const firstDays = firstDateOfYear.day();
        return getScrollRows() * 7 - firstDays;
    }, [stateValue, getScrollRows])

    const orderScroll = useCallback(async(e: React.UIEvent<HTMLDivElement>) => {
        if (!mutiple || isDragEvent) return;
        if (siderToScrollRef.current) {
            siderToScrollRef.current = false;
            return
        }
        const { clientHeight, scrollHeight, scrollTop } = e.currentTarget;
        let value = stateValue;
        const year = value.year();
        const scrollDates = getScrollDates();
        const _month = getMonthFormDates(scrollDates, year);
        _month && value.month(_month - 1);
        //  缩放页面时 更新实际滚动高度
        const scalingRatio = detectZoom()
        if (scalingRatio !== scalingRatioRef.current) {
            scalingRatioRef.current = scalingRatio;
            setStateValue(value);
            return;
        }

        if (scrollHeight < clientHeight + scrollTop + 10) {

            //  向下滚动时 如果为 up 则 不向上翻年
            if (!inChangeYearDirRef.current && onYearChange) {
                inChangeYearDirRef.current = true;
                await delayEvent(onYearChange, setYear, value, year + 1, 0);
            }
        } else if (Math.round(scrollTop) < Math.floor(10 * scalingRatio)) {
            // 向上 翻年时 不允许重复触发 翻年操作
            if (!inChangeYearDirRef.current && onYearChange) {
                inChangeYearDirRef.current = true;
                await delayEvent(onYearChange, setYear, value, year - 1, 11);
            }
        } else {
            // 滚动到 非翻页区域 后方可再次 翻页
            inChangeYearDirRef.current = false;
        }
        if (!value.isSame(value, 'month')) {
            if (scrollIntoValue) {
                onSelect && onSelect(value)
            } else {
                setStateValue(value);
                onSelect && onSelect(value);
            }
        }
    }, [mutiple, isDragEvent, stateValue, getScrollDates, onSelect])

    const getColumnHightlightDates = useCallback((index: number) => {
        setHighLightDate([]);
        const value = stateValue;
        const _value = value.clone().locale('en-us');
        // 默认 剩余周数
        const scrollRows = getScrollRows();
        const columnSelectNumber = typeof quickSelect === 'number' ? quickSelect : defaultColomns - scrollRows + 1;
        const changeDatesFormat = [];
        const scrollDates = getScrollDates();
        for (let i = 0; i < columnSelectNumber; i++) {
            // 找到此星期下的第一个日期
            let current = _value.clone().dayOfYear(scrollDates - (7 - 1 - index)).add(i * 7, 'day');
            const isCurrentDisabled = _disabledDate(disabledDate)(current);
            if (!isCurrentDisabled && current.year() === _value.year())
                changeDatesFormat.push(current.format('YYYY-MM-DD'))
        }
        return changeDatesFormat
    }, [stateValue, getScrollRows, quickSelect, getScrollDates])

    const selectColumn = useCallback((index: number) => {
        if (!quickSelect) return;
        // const {selectValuesMap} = state;
        const changeDatesFormat = getColumnHightlightDates(index);
        let flag = true;
        // 如果都是被选中 则 再次点击 清除
        if (changeDatesFormat.every(date => selectValuesMap.get(date) === true)) {
            flag = false;
        }
        // 业务决定是否 选择
        onQuickSelect && onQuickSelect({ changeValues: changeDatesFormat, isChecked: flag, value: selectValuesMap, direction: 'vertical' })
    }, [onQuickSelect, quickSelect, getColumnHightlightDates, selectValuesMap])

    const setColomnHighLight = useCallback((index: number) => {
        if (!quickSelect) return;
        const changeDatesFormat = getColumnHightlightDates(index);
        setHighLightDate(changeDatesFormat);
    }, [quickSelect, getColumnHightlightDates])

    const renderFCDateHeaderCell = useCallback((day: string, xindex: number, clsPrefix: string) => {
        let _weekStartsOn = getWeekStartsOn(weekStartsOn) || 0
        const renderDay = renderDateHeaderCell?.(day, xindex) || day;
        // 是否为日历周末头部添加背景色
        let headerMark = false;
        if (
            (markWeekend && _weekStartsOn === 1 && (xindex === 5 || xindex === 6)) ||
            (markWeekend && _weekStartsOn === 2 && (xindex === 4 || xindex === 5)) ||
            (markWeekend && _weekStartsOn === 3 && (xindex === 3 || xindex === 4)) ||
            (markWeekend && _weekStartsOn === 4 && (xindex === 2 || xindex === 3)) ||
            (markWeekend && _weekStartsOn === 5 && (xindex === 1 || xindex === 2)) ||
            (markWeekend && _weekStartsOn === 6 && (xindex === 0 || xindex === 1)) ||
            (markWeekend && (_weekStartsOn === 0 || !markWeekend) && (xindex === 6 || xindex === 0))
        ) {
            headerMark = true;
        }
        if (mutiple && quickSelect) {
            // 快选模式下 对齐
            if (xindex === 0) {
                return [
                    <th style={{ width: '22px' }} key={`${xindex}-0`}></th>,
                    <th
                        key={xindex}
                        role="columnheader"
                        title={_locale.langMap.clickSelectColomn}
                        onClick={() => selectColumn(xindex)}
                        onMouseEnter={() => setColomnHighLight(xindex)}
                        onMouseLeave={() => setHighLightDate([])}
                        className={
                            cx({
                                [`${clsPrefix}-column-header`]: true,
                                [`${clsPrefix}-column-select-header`]: quickSelect
                            })}
                    >
                        <span className={`${clsPrefix}-column-header-inner`}>
                            {renderDay}
                        </span>
                        <span className={`${clsPrefix}-column-header-inner-select`}>
                            {_locale.langMap.clickSelectColomn}
                        </span>
                    </th>
                ]
            }
            return [
                <th
                    key={xindex}
                    role="columnheader"
                    title={_locale.langMap.clickSelectColomn}
                    onClick={() => selectColumn(xindex)}
                    onMouseEnter={() => setColomnHighLight(xindex)}
                    onMouseLeave={() => setHighLightDate([])}
                    className={
                        cx({
                            [`${clsPrefix}-column-header`]: true,
                            [`${clsPrefix}-column-select-header`]: quickSelect
                        })}
                >
                    <span className={`${clsPrefix}-column-header-inner`}>
                        {renderDay}
                    </span>
                    <span className={`${clsPrefix}-column-header-inner-select`}>
                        {_locale.langMap.clickSelectColomn}
                    </span>
                </th>
            ]
        }
        const columnheader = (
            <th
                key={xindex}
                role="columnheader"
                className={
                    cx({
                        [`${clsPrefix}-column-header`]: true,
                        [`${clsPrefix}-column-header-mark`]: headerMark
                    })}
            >
                <span className={`${clsPrefix}-column-header-inner`}>
                    {renderDay}
                </span>
            </th>
        )
        if (xindex === 0 && mutiple) {
            return [
                <th style={{ width: '22px' }} key={`${xindex}-0`}></th>,
                columnheader
            ]
        }
        return columnheader
    }, [weekStartsOn, _locale, markWeekend, mutiple, quickSelect, renderDateHeaderCell, selectColumn, setColomnHighLight])

    const setCellHeightFunc = useCallback((_val?: any) => {
        if (!cellAdaptHeight) return
        setTimeout(() => {
            let bodyHeight = scrollDiv.current!?.getBoundingClientRect().height - 32
            let cellItemHeight = bodyHeight ? parseInt((bodyHeight / 6).toString()) : 81
            let _type = _val ? _val : propsType
            if (_type === 'month') {
                bodyHeight = rootRef.current?.parentNode ? (rootRef.current?.parentNode as any)?.getBoundingClientRect().height : rootRef.current?.getBoundingClientRect().height
                cellItemHeight = bodyHeight ? parseInt((bodyHeight / 4).toString()) : 81
                let selectCell = rootRef.current?.querySelectorAll('.wui-calendar-month-panel-month')
                if (selectCell && selectCell?.length > 0) {
                    selectCell.forEach((item: any) => {
                        item.style.height = cellItemHeight + 'px'
                    })
                }
            } else if (_type === 'date') {
                let selectCell = rootRef.current?.querySelectorAll('.wui-calendar-mutiple-selected-day')
                if (selectCell && selectCell?.length > 0) {
                    selectCell.forEach((item: any) => {
                        item.style.height = cellItemHeight + 'px'
                    })
                }
            }
            setCellHeight(cellItemHeight);
            let cellBody = rootRef.current?.querySelectorAll('.wui-calendar-cell-body-drag')
            if (cellBody && cellBody?.length > 0) {
                cellBody.forEach((item: any) => {
                    item.style.height = (cellItemHeight - 30 - (cellItemHeight - 30) % 20) + 'px'
                })
            }
        }, 100)
    }, [cellAdaptHeight])

    const renderFullDefaultDate = useCallback((current: Moment) => {
        const headerChilds =
            [
                <span key={current.format('YYYY-MM-DD') + "_span"} className={`${clsPrefix}-cell-header-date ${clsPrefix}-cell-header-solarday`}>
                    {current.date()}
                </span>
            ];
        if (allowLunar) {
            headerChilds.push(
                <span key={current.format('YYYY-MM-DD') + 'lunar-day'} className={`${clsPrefix}-cell-header-date ${clsPrefix}-cell-header-lunarday`}>
                    {
                        getLunarContent(current)
                    }
                </span>
            )
        }
        return headerChilds;
    }, [allowLunar])

    const renderFCFullBody = () => {
        // Use individual state variables directly
        return (
            <CalendarFullBody
                {...props}
                stateValue={stateValue}
                stateCurrent={current}
                fillSpaceStyle={fillSpaceStyle}
                stateType={stateType}
                selectValuesMap={selectValuesMap}
                focusedDay={focusedDay}
                highLightDate={highLightDate}
                scrollDivRef={scrollDiv}
                removeCellHighLight={() => setHighLightDate([])}
                calOrderScroll={orderScroll}
                calOnChange={onFCChange}
                onFCSelect={onFCSelect}
                calRenderDateHeaderCell={renderFCDateHeaderCell}
                setSelectValuesMap={(val: any) => setSelectValuesMap(val)}
                setFocusedDay={(val: any) => setFocusedDay(val)}
                setHighLightDate={(val: []) => setHighLightDate(val)}
                customInterval={customInterval}
                localeStore={_locale}
                timezone={timezone}
                serverTimezone={serverTimezone}
                enableTimezone={enableTimezone}
                convertToServerTimezone={convertToServerTimezone}
            />
        )
    }

    const renderMuti = () => {
        return (
            <CalendarMutiRender
                {...props}
                stateValue={stateValue}
                stateType={stateType}
                hourFillSpaceStyle={hourFillSpaceStyle}
                modalVisible={modalVisible}
                isFlag={isFlag}
                rootRef={rootRef}
                setScroll={setScroll}
                setCreatDom={setCreatDom}
                onClickUnfold={() => setIsFlag(true)}
                onCloseSlide={onCloseSlide}
                onOk={onOk}
                calOnChange={onFCChange}
                renderFCFullBody={renderFCFullBody}
                calTypeChange={typeChange}
                setStateValue={(val: any) => setStateValue(val)}
                sidebar={sidebar}
                timezone={timezone}
                serverTimezone={serverTimezone}
                enableTimezone={enableTimezone}
                convertToServerTimezone={convertToServerTimezone}
                customInterval={customInterval}
                isShowWeek={isShowWeek}
                localeStore={_locale}
            />
        )
    }

    // render method is now the function body
    const { style, className } = props;
    stateValue.locale(_locale.lang)
    let styleRoot = style || {};
    let classNameRoot = className || "";
    if (fillSpace) {
        styleRoot = { height: 0, ...styleRoot, ...fillSpaceStyle };
        classNameRoot = cx(`${clsPrefix}-fill-space`, className)
    }
    const _weekStartsOn = getWeekStartsOn(weekStartsOn)
    if ((_weekStartsOn === 'SUNDAY' || _weekStartsOn === 0) && !fullscreen && headerComponent && _locale?.lang == 'en-us') {
        moment.locale(_locale.lang, getMomentConfig(_weekStartsOn))
    }

    return (
        mutiple ? renderMuti() : <FullCalendar
            prefixCls={clsPrefix}
            Select={Select}
            fieldid={fieldid}
            getDateCellAttr={getDateCellAttr}
            onTimeEventsClick={onTimeEventsClick}
            onTypeChange={onPanelChange || onTypeChange}
            dateCellContentRender={dateCellContentRender || dateFullCellRender || renderFullDefaultDate}
            monthCellContentRender={monthCellContentRender || monthFullCellRender}
            calendar={generate}
            {...props}
            showSingleMonth={true}
            defaultType={mode || defaultType}
            disabledDate={disabledDate ? _disabledDate(disabledDate) : disabledDate}
            locale={_locale.langMap}
            lang={_locale.lang}
            onChange={onFCChange}
            onSelect={onFCSelect}
            headerComponent={headerComponent}
            renderDateHeaderCell={renderFCDateHeaderCell}
            markWeekend={markWeekend}
            ref={(r: any) => rootRef.current = r?.rootInstance}
            style={styleRoot}
            className={classNameRoot}
            weekStartsOn={_weekStartsOn === 'MONDAY' ? 1 : _weekStartsOn == undefined ? 0 : _weekStartsOn}
        />
    )
}

Calendar.defaultProps = defaultProps;

export default WebUI({ name: "calendar", defaultProps })(Calendar) as React.ComponentClass<Partial<CalendarProps<null>>>;
